<template>
    <div class="fill-height of-y">
        <v-row
                no-gutters
                class="of-y fill-height white"
        >
            <v-col class="fill-height of-y" cols="3">
                <div class="d-flex fill-height of-y pa-0 ma-0">
                    <div class="flex-grow-1 of-y-f">
                        <multi-select-list
                                class="flex-grow-1"
                                :items="users"
                                itemKey="id"
                                :showCheckBoxes="true"
                                :multiple="false"
                                headlineKey="fullNameDisabled"
                                subLineKey="username"
                                v-model="selectedUserID"
                                filterLabel="Filter Users"
                        >
                            <div slot="header" class="px-2 pt-2">

                                <v-btn
                                        small
                                        block
                                        color="primary"
                                        @click="createUserShow = !createUserShow"
                                >
                                    <v-icon left>mdi-account-plus</v-icon>
                                    Add User
                                </v-btn>

                            </div>
                        </multi-select-list>
                    </div>

                    <divider color="primary darken-1" :vertical="true"/>
                    <divider color="primary darken-1" :vertical="true"/>
                </div>

            </v-col>
<!--            <divider :vertical="true" color="grey"/>-->


            <v-divider :vertical="true"></v-divider>
            <v-col class="fill-height of-y" cols="9">
                <div class="fill-height">
                    <v-card class="fill-height of-y" tile>
                        <modify-user v-if="!!selectedUser" :edit-user="selectedUser" @save="upsertUser($event)">
                            <template v-slot:barcodes>
                                <manage-barcodes ref-key="fkUser" :ref-val="selectedUser.id"/>
                            </template>
                        </modify-user>

                    </v-card>
                </div>
            </v-col>


            <v-dialog
                    v-model="createUserShow"
                    :width="700"
                    persistent
            >
                <v-card class="of-y d-flex flex-column" :height="400">

                    <div class="d-flex align-center primary pl-3 pr-2 pt-1">
                        <div class="sub--text flex-grow-1">
                            Create User
                        </div>
                        <v-btn
                                icon
                                color="white"
                                small
                                @click="createUserShow = false"
                        >
                            <v-icon small>mdi-close</v-icon>
                        </v-btn>
                    </div>
                    <divider color="primary darken-1"/>
                    <div class="flex-grow-1">
                        <modify-user ref="addUser" v-if="createUserShow" :edit-user="createUserObj" @save="upsertUser($event)"/>
                    </div>
                </v-card>
            </v-dialog>

        </v-row>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import MultiSelectList from "../../General/Multi Select List/MultiSelectList";
import ModifyUser from "./ModifyUser";
import {waitForEvent} from "../../../core/socket";
import Divider from "../../General/Divider";
import ManageBarcodes from "../Manage Barcodes/ManageBarcodes";

export default {
    components: {ManageBarcodes, Divider, ModifyUser, MultiSelectList},
    props: {},
    data() {
        return {
            selectedUserID: null,
            createUserShow: false,
            createUserObj: null,
        }
    },
    watch: {

        createUserShow(val) {
            if (val)
                this.createUserObj = {
                    id: null,
                    name: null,
                    surname: null,
                    username: null,
                    disabled: false,
                    adminOptions: {
                        users: false,
                        setup: false,
                        limitToFarms: []
                    },
                }
        }
    },
    methods: {
        async upsertUser(event) {
            let {user, ref} = event;
            ref.loading = true;
            try {
                const eventID = await this.$newReq('POST', `setup/user`, user)
                const addedUserID = (await waitForEvent(eventID)).users.pop().id
                this.createUserShow = false
                this.selectedUserID = addedUserID;
                this.$snack.info('Changes saved')
            } catch (e) {
                console.log(e)
                this.$snack.netWorkError()
            } finally {
                ref.loading = false
            }
        }
    },
    computed: {
        ...mapGetters(['users']),
        selectedUser() {
            if (!this.selectedUserID)
                return null

            return this.users.filter(obj => obj.id === this.selectedUserID).pop()
        }
    },
}
</script>

<style scoped>

</style>